import React, { useMemo } from 'react'
import { useApi } from 'hooks/useApi'
import styles from './careersPage.module.css'
import CareerOpportunities from '../../components/CareersCard/CareerOppertunities'

const CareersPage = () => {
  const careers_header = '../../Assets/Images/Careers/careers_header.svg'
  
  // Environment variable for CMS base URL
  const CMS_BASE_URL = process.env.REACT_APP_CMS_BASE_URL;

  // Use the useApi hook
  const { data: careersData, loading, error } = useApi('/careers');

  // Transform the API data to match CareerOpportunities component expectation
  const transformedCareers = useMemo(() => {
    if (!careersData?.success || !careersData?.careers) return { careers: [] };
    
    const careers = careersData.careers.map(career => ({
      id: career.id,
      title: career.title,
      logo: career.logo ? `${CMS_BASE_URL}/attachments/${career.logo}` : null,
      description: career.description,
      rows: career.rows || []
    }));

    return { careers };
  }, [careersData, CMS_BASE_URL]);

  if (loading) {
    return (
      <div className={styles.careersContainer}>
        <div className={styles.contentContainer}>
          <h1 className={styles.heading}>Be Part of Our Mission</h1>
          <p className={styles.description}>
            We're looking for passionate people who desire to accept challenges,<br />build rapport with teams easily, and tell us what to do.
          </p>
          <img
            src={careers_header}
            alt="Connect Illustration"
            className={styles.image}
          />
          <h1 className={styles.heading2}>Career Opportunities</h1>
        </div>
        <div className={styles.loadingState}>
          <p>Loading career opportunities...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className={styles.careersContainer}>
        <div className={styles.contentContainer}>
          <h1 className={styles.heading}>Be Part of Our Mission</h1>
          <p className={styles.description}>
            We're looking for passionate people who desire to accept challenges,<br />build rapport with teams easily, and tell us what to do.
          </p>
          <img
            src={careers_header}
            alt="Connect Illustration"
            className={styles.image}
          />
          <h1 className={styles.heading2}>Career Opportunities</h1>
        </div>
        <div className={styles.errorState}>
          <p>Error loading career opportunities: {error}</p>
          <p>Please try again later.</p>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.careersContainer}>
      <div className={styles.contentContainer}>
        <h1 className={styles.heading}>Be Part of Our Mission</h1>
        <p className={styles.description}>
          We're looking for passionate people who desire to accept challenges,<br />build rapport with teams easily, and tell us what to do.
        </p>
        <img
          src={careers_header}
          alt="Connect Illustration"
          className={styles.image}
        />
        <h1 className={styles.heading2}>Career Opportunities</h1>
      </div>
      <div>
        {transformedCareers.careers.length > 0 ? (
          <CareerOpportunities jobs={transformedCareers} />
        ) : (
          <div className={styles.noCareersState}>
            <p>No career opportunities available at the moment.</p>
            <p>Please check back later for new openings.</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default CareersPage